
import { useState, useEffect } from "react";
import { useSelector,useDispatch } from "react-redux";
import { setup_user_todocs, update_DocsPrepareTemp_Status } from "../../slice/mainslice";
import { Checkbox, Grid, createStyles, Tooltip} from '@mantine/core';
import React from "react";

import ShowStapelSignDocsforUser from "./ShowStapelSignDocsforUser";

const havestapelsig = false

const useStyles = createStyles((theme) => ({
    margright: {
        marginRight: 10,
        cursor: 'pointer',
      },
    pafleft10:{
        paddingLeft: 3,
        cursor: `pointer`,
    },
    pointer:{
        cursor: `pointer`,
    }
}));

const SetupUserToDocs = (props: any) => {
    const { classes } = useStyles(); 
    const dispatch = useDispatch()
    const initparticipants = useSelector((state: any) => state.user.meetinguser)
    const iniusersigndocs = useSelector((state: any) => state.user.userhavetosigndocs)|| [];
    const[usersigndocs, setUserSignDocs] = useState<any>([]);

    const statusisgprepared = useSelector((state: any) => state.user.meetingdocs)
    const[statusSigPrep, setStatusSigPrep] = useState<any>(false);

   const selectetstapeluser = useSelector((state: any) => state.user.userhavetostapelsigndocs) || [];
//console.log("props.setdisable:",props.setdisable);
   // console.log(selectetstapeluser)
    
    useEffect(() => {

         //Filter Status des Signaturblock Switches
         const isSigPrepared = statusisgprepared.filter((obj: { resourceId: any; }) => {
            return obj.resourceId === props.resourceId
        });

        if (isSigPrepared.length !== 0){
           setStatusSigPrep(isSigPrepared[0].isSigPrepared) 
        }
   
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[statusisgprepared]);   



    useEffect(() => {
        if (props.setdisable) {
            setUserSignDocs([]);
            return;
        }

        const filteriniusersigndocs = iniusersigndocs.filter((obj: { resourceId: any; }) => {
            return obj.resourceId === props.resourceId
        });

        if (filteriniusersigndocs.length !== 0) {
            setUserSignDocs(filteriniusersigndocs[0].user);
        } else {
            setUserSignDocs([]);
        }

      // eslint-disable-next-line react-hooks/exhaustive-deps
      },[props.setdisable, iniusersigndocs]);

       


    const data = initparticipants.filter((obj: { role: any; }) => {
       return obj.role !== "gast"
    });

   

  
    const updateArray = (value: boolean,index: number) => {
        setUserSignDocs((prevusersigndocs: any) => {
          let updatedArray = [...prevusersigndocs];
          if (value){
           updatedArray.push(data[index].userId);
          }
          
          if (!value){
            updatedArray = updatedArray.filter((item: any) => item !== data[index].userId);
          }

          const user_to_docs = {
            resourceId: props.resourceId,
            user: updatedArray
          };

          //console.log(user_to_docs)
          dispatch(setup_user_todocs(user_to_docs))

         //console.log(updatedArray.length)
         //console.log(statusSigPrep)
          // Wenn der Switch für Set Signatur Blöcke Aktiv ist wird mit jeder User Auswahl der DRN aktualisiert
        if (statusSigPrep){

            if (updatedArray.length === 0){
               // Wenn das User Array leer ist das Dikument auf False setzen
                setDocissetup()
            } else {
                const setdocSigblockuser = {
                    drnId: props.drnId,
                    DocumentResourceId: props.resourceId,
                    userIds: updatedArray   
                };
                dispatch({ type: 'SIGNALR_SENDSETUSERFORSIGBLOCKSETUP', payload: setdocSigblockuser });
                } 
            }
 
        return updatedArray;
        });
      };


      const setDocissetup = () => {
        
        const setdocisprepareddata = {
          drnId: props.drnId,
          resourceId: props.resourceId,
          isSigPrepared: false    
      };

      const temppreparedata = {
          resourceId: props.resourceId,
          isSigPrepared: false 
      }

       dispatch({ type: 'SIGNALR_SENDSETDOCISPREPARED', payload: setdocisprepareddata });
       dispatch(update_DocsPrepareTemp_Status(temppreparedata))
      };


    const rows = (data || []).map((item: any, index: any) => {

        
        let fullname = item.lastName + " " + item.firstName
        let checked = false

       
      if (usersigndocs !== undefined && usersigndocs.length !== 0) {
       // console.log("usersigndocs:",usersigndocs)
        for (const userid of usersigndocs) {

            if (userid === item.userId && !props.setdisable) {
                checked = true 
            }
        }
      }

      // Logik um Stapeldokumente auszublenden
        const stapeldocsforuser = selectetstapeluser.filter(
            (obj: { participantId: string }) =>
                obj.participantId === item.id
            );

            const havestapelsig =
            stapeldocsforuser.some((stapeldocsforuser: { documentsSignModes: { resourceId: string; }[]; }) =>
                stapeldocsforuser.documentsSignModes?.some(
                (doc: { resourceId: string }) =>
                    doc.resourceId === props.resourceId
                )
            );


        return (
            <React.Fragment key={item.id || index}>
                <Grid.Col span={1} className={classes.margright}>
                {!havestapelsig  &&
                    <Tooltip label={fullname} multiline={true}>
                        <Checkbox className={classes.pafleft10} checked={checked} disabled={props.setdisable} onChange={(event) => updateArray(event.currentTarget.checked, index)} />
                    </Tooltip>
                }
                {havestapelsig  &&
                   <ShowStapelSignDocsforUser userId={item.userId} resourceId={props.resourceId} />
                }
                </Grid.Col>
            </React.Fragment>
        );
    });

    return (
        <>
            <Grid>
                {rows}
            </Grid>

        </>
    );
}

export default SetupUserToDocs;